import classNames from "classnames";
import React from "react";

interface PurpleHeaderCardProps {
  wide?: boolean
  href?: string
}

export const PurpleHeaderCard = (props: React.PropsWithChildren<PurpleHeaderCardProps>) => {
  const className = classNames("purple-header", { "purple-header-wide": props.wide });

  if (props.href) {
    return <a className={classNames(className, "purple-header-link")} href={props.href}>
      {props.children}
    </a>;
  }

  return <div className={className}>
    {props.children}
  </div>;
};

export const PurpleHeaderDivider = () => <div className="purple-header-divider" />;

export const PurpleHeaderVerticalDivider = () => <div className="purple-header-vertical-divider" />;
